export const SET_LOCALE = "SET_LOCALE";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_TOKENS = "UPDATE_TOKENS";
export const SET_USER_PHONE = "SET_USER_PHONE";
export const SET_LOGIN_TRANSACTION_ID = "SET_LOGIN_TRANSACTION_ID";
export const SET_OTP_OPERATION_ID = "SET_OTP_OPERATION_ID";
export const LOGIN_USER = "LOGIN_USER";
export const SET_USER_DATA = "SET_USER_DATA";
export const LOAD_USER_DATA = "LOAD_USER_DATA";
export const UPDATE_CART_ITEMS_COUNT = "UPDATE_CART_ITEMS_COUNT";
export const SET_WSS_CONNECTION = "SET_WSS_CONNECTION";
